<template>
    <div class="mx-auto">
        <b-card>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="mb-3 col-2" style="float:right"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros"
                              style="float: right; margin-right: 10px; height: 32px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>

            <b-table
                    id="regrasPagamento"
                    :items="resultado"
                    :fields="fields"
                    striped
                    small
                    responsive
                    :busy="configTable.load"
                    show-empty
                    hover
                    bordered
                    class="mb-0"
                    head-variant="light">
                <div slot="table-busy" class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
                <template slot="empty">
                    <p class="my-auto">Nenhuma Requisição encontrada.</p>
                </template>
                <template v-slot:head(0)="{ item }">
                    Nº Requisição <i class="filter" :class="!isEmpty(filtros.numeroRequisicaoSub) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Nº Requisição', 'mascara', '', '########', $event)"></i>
                </template>
                <template v-slot:cell(0)="{ item }">
                    <p class="text-center">
                        <a class="link" @click="abrirExtrato(item)">
                            {{ item.numeroRequisicao }}
                        </a>
                    </p>
                </template>
                <template v-slot:head(1)="{ item }">
                    Tipo Requisição <i class="filter" :class="!isEmpty(filtros.tipoRequisicacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo Requisição', 'checkbox', dados.tiposRequisicao, null, $event)"></i>
                </template>
                <template v-slot:cell(1)="{ item }">
                    {{ item.tabelaOrigem == 0 ? item.tipoRequisicao.nome + " - " + item.receita : item.receita }}
                </template>
                <template v-slot:head(2)="{ item }">
                    Processo(s) <i class="filter" :class="!isEmpty(filtros.cnjSub) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Processo(s)', 'mascara', '', 'cnj', $event)"></i>
                </template>
                <template v-slot:cell(2)="{ item }">
                    <p v-if="item.cnj.length == 1">
                        {{ item.cnj[0] }}
                    </p>
                    <p v-if="!item.abrirTodos && item.cnj.length > 1">
                        {{ item.cnj[0] }} <a class="link" @click="expandirOutros(item)">e outros</a>
                    </p>
                    <p v-for="cnj in item.cnj" v-if="item.abrirTodos && item.cnj.length > 1">
                        {{ cnj }}
                    </p>
                </template>
                <template v-slot:head(3)="{ item }">
                    CDA(s) <i class="filter" :class="!isEmpty(filtros.cdaSub) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CDA(s)', 'mascara', '', '##########', $event)"></i>
                </template>
                <template v-slot:cell(3)="{ item }">
                    <p class="text-center" v-if="item.cdas.length == 0">
                        -
                    </p>
                    <span v-for="(cda, index) in item.cdas">
                    <span v-if="index > 0">, </span>
                    <a class="link" @click="abrirModalExtratoCda(cda)">{{cda}}</a>
                  </span>
                </template>
                <template v-slot:head(4)="{ item }">
                    Devedor <i class="filter" :class="!isEmpty(filtros.contribuinte) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Devedor', 'texto', '', null, $event)"></i>
                </template>
                <template v-slot:cell(4)="{ item }">
                    {{ item.devedor }}
                </template>
                <template v-slot:head(5)="{ item }">
                    Data Emissão <i class="filter" :class="!isEmpty(filtros.dataEmissao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Emissão', 'data', '', null, $event)"></i>
                </template>
                <template v-slot:cell(5)="{ item }">
                    <p class="text-center">
                        {{ item.dataEmissao }}
                    </p>
                </template>
                <template v-slot:head(6)="{ item }">
                    Tipo Pgto <i class="filter" :class="!isEmpty(filtros.tipoPagamento) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo Pgto', 'checkbox', dados.tiposPagamento, null, $event)"></i>
                </template>
                <template v-slot:cell(6)="{ item }">
                    {{ item.tipoPagamento }}
                </template>
                <template v-slot:head(7)="{ item }">
                    Forma Pgto <i class="filter" :class="!isEmpty(filtros.formaPagamento) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Forma Pgto', 'checkbox', dados.formasPagamento, null, $event)"></i>
                </template>
                <template v-slot:cell(7)="{ item }">
                    {{ item.formaPagamento }}
                </template>
                <template v-slot:head(8)="{ item }">
                    Valor (R$) <i class="filter" :class="!isEmpty(filtros.valor) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor (R$)', 'numerico', '', null, $event)"></i>
                </template>
                <template v-slot:cell(8)="{ item }">
                    <p class="text-right" v-if="item.valor != null">
                        {{ item.valor | currency }}
                    </p>
                </template>
                <template v-slot:head(9)="{ item }">
                    Usuário Responsável <i class="filter" :class="!isEmpty(filtros.usuario) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Usuário Responsável', 'texto', '', null, $event)"></i>
                </template>
                <template v-slot:cell(9)="{ item }">
                    {{ item.usuarioResponsavel }}
                </template>
                <template v-slot:head(10)="{ item }">
                    Situação Requisição
                    <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                       v-b-modal.modal-info-situacao
                       v-b-popover.hover.top="'Clique aqui para saber mais sobre Situação da Requisição'"></i>
                    <i class="filter" :class="!isEmpty(filtros.situacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação Requisição', 'checkbox', dados.statusRequisicao, null, $event)"></i>
                </template>
                <template v-slot:cell(10)="{ item }">
                    <p :style="'color: ' + item.cor">
                        {{ item.situacao }}
                    </p>
                </template>
            </b-table>

            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <div class="registros-encontrados-valor" style="float: right;">
                        <span>{{configTable.perPage != 'Todos' ? configTable.rows : resultado.length}}</span>
                    </div>
                    <div class="registros-encontrados" style="float: right;">
                        <span>Requisições Encontradas:</span>
                    </div>
                </b-col>
            </b-row>
        </b-card>

        <b-modal
                ref="modal-info-situacao"
                id="modal-info-situacao"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Tipos de Situação da Requisição"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p><span style="color: #ffa500"><strong>Aguardando Aprovação:</strong></span> requisição de honorários gerada por usuário do perfil administrativo (estagiário ou servidor) e aguardando aprovação por algum procurador.</p>
                    <p><span style="color: #ffa500"><strong>Aguardando Validação:</strong></span> requisição de honorários com a forma de pagamento por transferência bancária e aguardando validação pelo GOFS e pelo tesoureiro do FEPGE.</p>
                    <p><span style="color: #ffa500"><strong>Pendente:</strong></span> requisição de honorários do tipo de pagamento à vista aguardando a confirmação de pagamento do boleto único ou do tipo de pagamento parcelamento aguardando a confirmação de pagamento do boleto da primeira parcela.</p>
                    <p><span style="color: #ffa500"><strong>Em dia:</strong></span> requisição de honorários do tipo de pagamento parcelamento com todas as parcelas vencidas pagas e ainda com parcelas a vencer.</p>
                    <p><span style="color: #ffa500"><strong>Atrasada:</strong></span> requisição de honorários do tipo de pagamento parcelamento com uma ou duas parcelas vencidas.</p>
                    <p><span style="color: #ff2e17"><strong>Cancelada:</strong></span> requisição de honorários do tipo de pagamento à vista com boleto único vencido e não pago, do tipo de pagamento parcelamento com o boleto da primeira parcela vencido e não pago ou cancelado por ação do usuário.</p>
                    <p><span style="color: #ff2e17"><strong>Rescindida:</strong></span> requisição de honorários do tipo de pagamento parcelamento rescindido após o registro de pagamento de uma ou mais parcelas ou rescindido por ação do usuário após o registro de pagamento de uma ou mais parcelas.</p>
                    <p><span style="color: #0073c0"><strong>Quitada:</strong></span> requisição de honorários do tipo de pagamento à vista com confirmação de pagamento ou do tipo de pagamento parcelamento com confirmação de pagamento de todas as parcelas.</p>
                    <p><span style="color: #0073c0"><strong>Encaminhada CES:</strong></span> requisição de honorários de titularidade da Caixa Especial de Sucumbência - CES encaminhada à CES para cobrança.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info')"> Fechar</b-button>
            </template>
        </b-modal>

        <ExtratoComunicacaoTransferencia
                ref="extratoComunicacaoTransferencia"
                :loading="loading"
                @closeModal="(update) => { updated = update; closeModal(); }" 
            />
        <ExtratoReceitasDiversas
                ref="extratoReceitasDiversas"
                :loading="loading"
                @closeModal="(update) => { updated = update; closeModal(); }" 
        />
        <ExtratoHonorariosAcaoJudicial
                ref="extratoHonorariosAcaoJudicial"
                :loading="loading"
                @closeModal="(update) => { updated = update; closeModal(); }" 
        />
        <ExtratoHonorariosProtesto
                ref="extratoHonorariosProtesto"
                :loading="loading"
                @closeModal="(update) => { updated = update; closeModal(); }" 
        />
        <ExtratoHonorariosEfSefa
                ref="extratoHonorariosEfSefa"
                :loading="loading"
                @closeModal="(update) => { updated = update; closeModal(); }" 
        />
        <ExtratoHonorariosComTransfEfSefa
                ref="extratoHonorariosComTransfEfSefa"
                :loading="loading"
                @closeModal="(update) => { updated = update; closeModal(); }" 
        />
        <ExtratoCda
            ref="extratoCda"
            :loading="loading" />
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompBotaoExibirOcultarColuna from "../../shared/components/CompBotaoExibirOcultarColuna";
    import ExtratoComunicacaoTransferencia from "../../shared/components/ExtratoComunicacaoTransferencia"
    import ExtratoHonorariosAcaoJudicial from "../../shared/components/ExtratoHonorariosAcaoJudicial";
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";
    import ExtratoReceitasDiversas from "../../shared/components/ExtratoReceitasDiversas";
    import ExtratoHonorariosProtesto from "../../shared/components/ExtratoHonorariosProtesto";
    import ExtratoHonorariosEfSefa from "../../shared/components/ExtratoHonorariosEfSefa";
    import ExtratoHonorariosComTransfEfSefa from "../../shared/components/ExtratoHonorariosComTransfEfSefa";
    import ExtratoCda from "../../shared/components/ExtratoCda";

    export default {
    props: ['resultado', 'configTable', 'filtroComponente', 'filtros', 'loading'],
    components: {
        ExtratoCda,
        ExtratoHonorariosComTransfEfSefa,
        ExtratoHonorariosEfSefa,
        ExtratoHonorariosProtesto,
        ExtratoComunicacaoTransferencia,
        ExtratoReceitasDiversas,
        CompBotaoExibirOcultarColuna,
        ExtratoHonorariosAcaoJudicial,
        ModalAlterarDevedor
    },
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.$emit('consultar');
        }
    },
    data() {
        return {
            updated: false,
            urlApi: null,
            token: null,
            showColunms: [],
            fields: [],
            dados: {
                formasPagamento: null,
                tiposPagamento: null,
                statusRequisicao: null,
                uf: [],
                municipios: [],
                tiposRequisicao: [
                    {id: 1, nome: "Honorários de Ação Judicial"},
                    {id: 4, nome: "Honorários de EF - Base de Cálculo D.A. SEFA"},
                    {id: 3, nome: "Honorários de Protesto"},
                    {id: 0, nome: "Receita Diversa"},
                ]
            },
            messageModal: {
                message: null,
                variant: null
            },
            itemCarregado: {
                numeroRequisicao: null
            },
            receitaDiversa: {
                tipoRequisicao: null,
                dataCriacao: null,
                status: null,
                corStatus: null,
                formaPagamento: null,
                tipoPagamento: null,
                valor: null,
                quitada: null,
                observacoes: null,
                anexos: [],
                contribuinte: {
                    codContribuinte: null,
                    tipoContribuinte: {
                        id: null,
                        nome: null
                    },
                    nome: null,
                    indAtivo: null,
                    documento: null,
                    telefone: null,
                    email: null,
                    cep: null,
                    logradouro: null,
                    numero: null,
                    complemento: null,
                    bairro: null,
                    uf: {
                        id: null,
                        nome: null
                    },
                    municipio: {
                        codMunicipio: null,
                        nome: null
                    },
                },
                parcelas: [],
            },
            fieldsPagamento: [
                {
                    key: 'numeroParcela',
                    label: 'Parcela.'
                },
                {
                    key: 'codigoBarras',
                    label: 'Código de Barras'
                },
                {
                    key: 'dataGeracao',
                    label: 'Data Geração'
                },
                {
                    key: 'dataVencimento',
                    label: 'Data Vencimento'
                },
                {
                    key: 'dataPagamento',
                    label: 'Data Pagamento'
                },
                {
                    key: 'valor',
                    label: 'Valor Pago'
                },
                {
                    key: 'situacao',
                    label: 'Situação'
                }
            ],
            contribuinte: {
                nome: null,
                documento: null,
                telefone: null,
                email: null,
                cep: null,
                logradouro: null,
                numero: null,
                complemento: null,
                bairro: null,
                uf: null,
                municipio: null
            },
        }
    },
    computed: {
        getTheme () {
            return this.$store.getters.getTheme
        },
        currentPage() {
            return this.configTable.currentPage;
        },
        perPage() {
            return this.configTable.perPage;
        },
    },
    methods: {
        async obterColunasUsuario() {
            const funcionalidade = 'pesquisas';

            axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                response.data.forEach((field, i) => {
                    if(field.descricao == 'CDA(s)' && !this.verificarValorVazio(this.filtros.cda)) {
                        field.ativo = true;
                    }

                    if (field.ativo) {
                        this.showColunms.push(i)
                    }
                    this.fields.push({
                        key: `${i}`,
                        label: `${field.descricao}`,
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1);
                this.fields[i].thClass = 'd-none';
                this.fields[i].tdClass = 'd-none';
                ativo = false
            } else {
                this.showColunms.push(i);
                this.fields[i].thClass = '';
                this.fields[i].tdClass = '';
                ativo = true
            }

            this.atualizarConfiguracaoColunm(i, ativo)
        },

        ativarColunaCda() {
            for (let i = 0; i < this.fields.length; i++) {
                if(this.fields[i].label == 'CDA(s)' && !this.showColunms.includes(i)) {
                    this.showColunms.push(i);
                    this.fields[i].thClass = '';
                    this.fields[i].tdClass = '';
                }
            }
        },

        async atualizarConfiguracaoColunm(i, ativo) {
            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            };
            axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        async listarFormaPagamento() {
            axios.get(`${this.urlApi}/v1/receitasDiversas/listarFormaPagamento`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.formasPagamento = response.data
            })
        },
        async listarTiposPagamento() {
            axios.get(`${this.urlApi}/v1/regrasPagamento/listarTiposPagamento`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.tiposPagamento = response.data
            })
        },
        async listarStatusRequisicao() {
            axios.get(`${this.urlApi}/v1/pesquisas/listarStatusRequisicao`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.statusRequisicao = response.data
            })
        },
        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        },
        abrirExtrato(item) {
            if(item.tabelaOrigem == 0) {
                this.$refs['extratoReceitasDiversas'].abrirExtrato(item);
            } else if(item.tabelaOrigem == 1) {
                this.$refs['extratoHonorariosAcaoJudicial'].abrirExtrato(item);
            } else if (item.tabelaOrigem === 2) {
                this.$refs['extratoComunicacaoTransferencia'].abrirExtrato(item)
            } else if (item.tabelaOrigem === 3) {
                this.$refs['extratoHonorariosProtesto'].abrirExtrato(item)
            } else if (item.tabelaOrigem === 4) {
                this.$refs['extratoHonorariosEfSefa'].abrirExtrato(item)
            } else if (item.tabelaOrigem === 5) {
                this.$refs['extratoHonorariosComTransfEfSefa'].abrirExtrato(item)
            }
        },
        closeModal() {
            this.$emit('consultarComScroll', this.updated);
            this.updated = false;
        },
        limparFiltros() {
            this.$emit('limparFiltros');
        },
        abrirModalExtratoCda(numeroCda) {
            this.$refs['extratoCda'].abrirExtrato(numeroCda);
        },
        expandirOutros(item) {
            item.abrirTodos = true;
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        this.obterColunasUsuario();

        this.listarFormaPagamento();
        this.listarTiposPagamento();
        this.listarStatusRequisicao();
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

.vue-form-wizard a:hover {
  text-decoration: underline !important;
}

</style>
